<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<input
			type="text"
			:value="value.model"
			@input="emitValue('input', $event.target.value)"
			@change="emitValue('change', $event.target.value)"
			class="form-control input-sm"
			:placeholder="placeholder"
			:disabled="disabled"
		/>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
import mixinInputModel from './mixinInputModel'
export default {
	mixins: [mixinInputModel]
}
</script>
